import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
    selector: 'unauthorizedAccount',
    templateUrl: './unauthorizedAccount.component.html',
    styleUrls:['./unauthorized.component.css']
})
export class UnauthorizedAccount implements OnInit {

    codeErreur: string;

    constructor(private route: ActivatedRoute, private oauthService: OAuthService, private storageService: StorageService) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => { this.codeErreur = params['code'] });
    }

    logout() {
        this.storageService.clearStorage();
        this.oauthService.logOut();
    }
}